import {locales} from './constants/locations'
import {corporateURL} from './constants/index'
export const getCurrentLocal = ()=>{
	const currentPath = window.location.pathname; 

	const firstSegment = currentPath.split('/')[1];
	if(locales.includes(firstSegment)){
		return firstSegment
	}
	else{
		return 'en-us'
	}
}

export const checkReplaceUrl = (url) =>{
	// const currentHost = window.location.origin; 
	// const defaultBaseUrl = "https://www.shop.sandisk.com/";
	// const cloudfrontBaseUrl = "https://dqf88de43dm8k.cloudfront.net/search";
	
	// let baseUrl;
	
	// if (currentHost === "http://localhost:3000" || currentHost === cloudfrontBaseUrl) {
	// 	baseUrl = defaultBaseUrl;
	// } else {
	// 	baseUrl = currentHost; 
	// }
	// 	if (/^https?:\/\//i.test(url)) {
	// 	return url; 
	// 	} 
	// 	else {
	// 		console.log('justdoit',  baseUrl);
	// 		console.log('justdoiturl',  url);
	// 		if(url){
	// 			return baseUrl + url.replace(/^\//, "");
	// 		}
			
	// 	}
	const baseUrl = corporateURL; // Your predefined base URL

  try {
    const parsedUrl = new URL(url);

    return url;
  } catch (error) {
    if (typeof url === "string") {
      const cleanUrl = url.startsWith("/") ? url : `/${url}`;
      return `${baseUrl}${cleanUrl}`;
    }

    console.log("Invalid URL provided:", error);
  }

}